// Tracks the requisites-cascade lifecycle once the mutation itself has settled; whether the
// mutation is in flight is read from its own isLoading instead of being duplicated here.
export enum CascadeStatus {
  /** Not fired yet for the current attempt (initial value, or after resetCascade()). The
   *  auto-cascade effect fires from here; for a fixed-payment-type order the loader is already
   *  shown in this state (hasFixedPaymentTypeAwaitingCascade). */
  Idle = 'idle',
  /** startRequisitesCascade returned 200 and the order was updated from its response. Terminal
   *  for this attempt — only NewTradeMethodReset brings it back to Idle. */
  Done = 'done',
  /** The request errored (proxy timeout / 5xx) and we don't know whether the backend search ran.
   *  Keeps the loader up until the compensating refetch lands, then -> Idle if the order left
   *  New, -> RetryScheduled or Failed otherwise. */
  Reconciling = 'reconciling',
  /** The refetch confirmed the order is still New without requisites, i.e. the backend never
   *  started the search. Keeps the loader up and goes back to Idle after a delay, which re-fires
   *  the cascade. Used only while auto-retries are left. */
  RetryScheduled = 'retry_scheduled',
  /** Same as RetryScheduled, but the auto-retries are used up, or the error wasn't worth retrying
   *  (4xx, 504). Drops the loader so the customer gets the trade-method picker. Never re-fires on
   *  its own: a pick from the picker resets to Idle with the auto-cascade blocked, and
   *  NewTradeMethodReset resets to Idle with it allowed again. */
  Failed = 'failed',
}
